export class Configuration {
  static get() {
    if (window.location.hostname.indexOf('169.254.0.151') > -1) {
      return {
        apiBackend: 'http://169.254.0.151:8000/service/',
        headerToken: 'X-AUTH-TOKEN',
        authLogin: ':8400',
      }
    }
    else if (window.location.hostname.indexOf('150.107.137.59') > -1) {
      return {
        apiBackend: 'http://150.107.137.59:5656/service/',
        headerToken: 'X-AUTH-TOKEN',
        authLogin: ':8400',
      }
    } else if (window.location.hostname.indexOf('localhost') > -1) {
      return {
        apiBackend: 'http://localhost:8000/service/',
        headerToken: 'X-AUTH-TOKEN',
        authLogin: ':8400',
      }
    } else {
      return {
        apiBackend: '/service/',
        headerToken: 'X-AUTH-TOKEN',
        authLogin: ':8400',
      }
    }
  }
}
